<template>
  <v-container fluid v-if="order!=null">
    <vue-headful :title="`Order Detail - Halalize for Business`" />
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/commerce/orders/live?ref=detail' }">ออเดอร์สัปดาห์นี้</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/view/shop/'+order.shop.ref_no }">{{order.shop.name}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{order.order_reference}}-{{order.order_id | numFormat('00000')}}</el-breadcrumb-item>
    </el-breadcrumb>
    <v-layout row wrap class="mt-4">
      <v-flex xs12 sm12 md8>
        <div class="grid-content bg-purple">
          <el-card class="box-card">
            <template v-if="order.status!='cancelled'">
              <ul
                class="progressbar i-5"
                v-if="order.order_type=='delivery'||order.order_type=='commerce'"
              >
                <li :class="{'active':steps[0]==1}">สั่งซื้อ</li>
                <li :class="{'active':steps[1]==1}">ชำระเงิน</li>
                <li :class="{'active':steps[2]==1}">ยืนยันออเดอร์</li>
                <li :class="{'active':steps[3]==1}">กำลังแพ็คสินค้า</li>
                <li :class="{'active':steps[4]==1}">จัดส่งแล้ว</li>
              </ul>

              <div style="clear:both;" class="pb-3"></div>
            </template>
            <!--
            <div
              v-if="order.status=='pending'"
              class="pa-1 text-xs-center white--text grey"
            >รอชำระเงิน</div>
            <div v-else-if="order.status=='new'" class="pa-1 text-xs-center white--text red">มาใหม่</div>
            <div
              v-else-if="order.status=='processing'"
              class="pa-1 text-xs-center white--text blue darken-2"
            >กำลังแพ็คสินค้า</div>
            <div
              v-else-if="order.status=='cooking'"
              class="pa-1 text-xs-center white--text blue darken-4"
            >กำลังแพ็คสินค้า</div>
            <div
              v-else-if="order.status=='completed'"
              class="pa-1 text-xs-center white--text green"
            >เรียบร้อยแล้ว</div>
            -->
            <div
              v-else-if="order.status=='cancelled'"
              class="pa-1 text-xs-center white--text grey"
            >ยกเลิกแล้ว</div>
            <div v-else class="pa-1 text-xs-center white--text orange">{{order.status}}</div>
            <section class="pa-3">
              <v-layout>
                <v-flex xs0 md4></v-flex>
                <v-flex xs12 md8 class="text-xs-right">
                  <!--
                  <el-row :gutter="0" class="title mb-3">
                    <el-col :span="12">
                      <strong>Order Status :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">
                      <el-tag type="warning" size="large">{{order.status}}</el-tag>
                    </el-col>
                  </el-row>
                  -->
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>หมายเลขออเดอร์ :</strong>
                    </el-col>
                    <el-col
                      :span="12"
                      class="text-xs-right"
                    >{{order.order_reference}}-{{order.order_id | numFormat('00000')}}</el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>สร้างเมื่อ :</strong>
                    </el-col>
                    <el-col
                      :span="12"
                      class="text-xs-right"
                    >{{order.created_at | moment("DD/MM/YY HH:mm")}}</el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>ประเภทการสั่งซื้อ :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">
                      <div v-if="order.order_type=='pickup'">
                        <i class="fas fa-shopping-bag"></i> รับเองที่ร้าน
                      </div>
                      <div v-if="order.order_type=='delivery'">
                        <i class="fas fa-motorcycle"></i> เดลิเวอรี่
                      </div>
                      <div v-if="order.order_type=='commerce'">
                        <i class="fas fa-shopping-cart"></i> อีคอมเมิร์ซ
                      </div>
                      <div v-if="order.order_type=='coupon'">
                        <i class="fas fa-ticket-alt"></i> คูปอง/วอเชอร์โค้ด
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>การชำระเงิน :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">
                      <div v-if="order.payment_type=='transfer'">โอนเงิน</div>
                      <div v-if="order.payment_type=='cash'">ชำระเงินสด</div>
                      <div v-if="order.payment_type=='creditcard'">บัตรเครดิต</div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="0" class="mt-2 subtitle">
                    <el-col :span="12">
                      <strong>ช่องทางการขาย :</strong>
                    </el-col>
                    <el-col :span="12" class="text-xs-right">
                      <div v-if="order.order_channel=='liff'">Line Official Account</div>
                      <div v-else>{{order.order_channel}}</div>
                    </el-col>
                  </el-row>
                </v-flex>
              </v-layout>
            </section>
            <v-divider></v-divider>
            <section class="pa-3" v-if="order.order_type=='delivery'">
              <h2 class="subtitle mb-3">ข้อมูลการจัดส่ง</h2>
              <v-layout>
                <v-flex xs12 sm12 md10>
                  <ul class="my-progress large" v-if="order.order_type=='delivery'">
                    <li class="progress__item progress__item--completed">
                      <p class="progress__title">{{order.shop.name}}</p>
                      <p class="progress__info">{{order.shop.formatted_address}}</p>
                    </li>
                    <li class="progress__item progress__item--active">
                      <p class="progress__title">
                        <span
                          v-if="order.delivery_info_json.whereTo.address.text"
                        >{{order.delivery_info_json.whereTo.address.text}}</span>
                        <span v-else>{{order.delivery_info_json.whereTo.address}}</span>
                      </p>
                    </li>
                  </ul>
                  <!--
                  <ul class="routes large">
                    <li>
                      <strong>{{order.shop.name}}</strong>
                      <p></p>
                    </li>
                    <li>
                      <strong
                        v-if="order.delivery_info_json.whereTo.label"
                      >{{order.delivery_info_json.whereTo.label}}</strong>
                      <p
                        v-if="order.delivery_info_json.whereTo.address.text"
                      >{{order.delivery_info_json.whereTo.address.text}}</p>
                      <p v-else>{{order.delivery_info_json.whereTo.address}}</p>
                    </li>
                  </ul>
                  -->
                </v-flex>
              </v-layout>
              <div class="mt-0">
                <strong class="my-label">ระยะทาง :</strong>
                {{order.distance/1000 | numFormat('0.00')}} km
              </div>
              <div class="mt-1">
                <strong class="my-label">เวลาจัดส่ง :</strong>
                {{order.datetime_received | moment("DD/MM/YY HH:mm")}}
                <el-tag
                  v-if="order.cluster_id!=null"
                  size="mini"
                  type="info"
                  class="ml-1"
                >รอบส่ง {{order.shop.cluster_json.find(x=>x.id==order.cluster_id).delivery}}</el-tag>
              </div>
            </section>
            <section class="pa-3" v-if="order.order_type=='pickup'">
              <h2 class="subtitle mb-3">ข้อมูลการรับอาหาร</h2>

              <div class="mt-4">
                <strong class="my-label">รับอาหารที่ :</strong>
                {{order.shop.name}}
                <p>{{order.shop.formatted_address}}</p>
              </div>
              <div class="mt-4">
                <strong class="my-label">Pickup on :</strong>
                {{order.datetime_received | moment("DD/MM/YY HH:mm")}}
              </div>
            </section>
            <v-divider></v-divider>
            <section class="pa-3">
              <h2 class="subtitle mb-3">ข้อมูลลูกค้า</h2>
              <v-layout>
                <v-flex xs12 style="line-height:30px;">
                  <div>
                    <strong class="my-label">ชื่อ :</strong>
                    {{recipient.name}}
                    <br />
                    <span>
                      <strong class="my-label">เบอร์โทร :</strong>
                      {{recipient.mobile}}
                    </span>
                    <template>
                      <br />
                      <span>
                        <strong class="my-label">อีเมล :</strong>
                        {{recipient.email}}
                      </span>
                    </template>
                    <br />
                    <span>
                      <strong class="my-label">ที่อยู่จัดส่ง :</strong>
                      {{shippingAddress.place_detail.address}} {{shippingAddress.place_detail.sub_district}} {{shippingAddress.place_detail.district}} {{shippingAddress.place_detail.province}} {{shippingAddress.place_detail.postcode}}
                    </span>
                  </div>
                </v-flex>
              </v-layout>
            </section>
            <v-divider></v-divider>
            <section class="pa-3">
              <h2 class="subtitle mb-3">คำสั่งซื้อ (#{{order.order_id | numFormat('0000000')}})</h2>
              <template v-if="order.order_basket.product_list.length>0">
                <el-row
                  :gutter="10"
                  v-for="(item, index) in order.order_basket.product_list"
                  v-bind:key="index"
                  style="border-bottom:1px solid #eee; min-height:90px;"
                >
                  <el-col :span="2" class="mb-3">
                    <span>{{item.quantity}} x</span>
                  </el-col>
                  <el-col :span="17" class="mb-3">
                    {{item.name}}
                    <div v-if="item.modifiers!=null">
                      <div
                        class="modifiers"
                        style="padding-left: 20px;"
                        v-for="(subject, index) in item.modifiers"
                        v-bind:key="index"
                      >
                        {{subject.title}}
                        <div v-if="!subject.duplicate">
                          <div v-for="(item, j) in subject.items" v-bind:key="j">
                            <li class="choice-item" v-if="item.checked">
                              {{item.name}}
                              <span v-if="item.price>0">({{item.price}} ฿)</span>
                            </li>
                          </div>
                        </div>
                        <div v-if="subject.duplicate">
                          <li
                            v-for="(item, j) in subject.items"
                            v-bind:key="j"
                          >{{item.name}} {{item.checked}}</li>
                        </div>
                      </div>
                    </div>
                    <div class="mt-2" v-if="item.remark !=null">
                      <span
                        style="clear: left; border-radius:6px; "
                        class="py-2 px-4 grey lighten-3"
                      >
                        <i class="far fa-comment-dots"></i>
                        {{item.remark }}
                      </span>
                    </div>
                  </el-col>
                  <el-col
                    :span="5"
                    class="mb-3 text-xs-right"
                  >฿ {{item.line_subtotal | numFormat('0,0')}}</el-col>
                </el-row>

                <el-row :gutter="10" class="subtitle mt-3">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">ค่าอาหาร</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.food | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row :gutter="10" class="subtitle">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">ค่าจัดส่ง</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{parseFloat(order.amount.delivery)+parseFloat(order.amount.delivery_tax) | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row :gutter="10" class="subtitle" v-if="order.amount.extra>0">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">บริการเสริม (เก็บเงินปลายทาง)</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.extra | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row
                  :gutter="10"
                  class="subtitle green--text promotion mb-3 py-2"
                  v-if="order.amount.discount<0"
                >
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="14" class="mb-3">
                    ส่วนลด
                    <div class="green--text font-weight-bold" v-if="order.promotion_json!=null">
                      <v-icon small class="green--text">fa fa-tag</v-icon>
                      {{order.promotion_json[0].promotion_title}}
                    </div>
                  </el-col>
                  <el-col
                    :span="8"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.discount | numFormat('0,0.00')}}</el-col>
                </el-row>
                <el-row :gutter="10" class="title">
                  <el-col :span="2" class="mb-3"></el-col>
                  <el-col :span="12" class="mb-3">รวมทั้งหมด</el-col>
                  <el-col
                    :span="10"
                    class="mb-3 text-xs-right"
                  >฿ {{order.amount.total | numFormat('0,0.00')}}</el-col>
                </el-row>
              </template>
            </section>
            <v-divider></v-divider>
            <section class="pa-3">
              <h2 class="subtitle mb-0">หมายเหตุ</h2>
            </section>
            <div class="px-3 mb-3">{{order.remark_public}}</div>
            <template v-if="order.payment_type=='creditcard' && payment!=null">
              <v-divider></v-divider>
              <section class="pa-3">
                <h2 class="subtitle mb-3">Credit Card Info</h2>
                <v-layout>
                  <v-flex xs12>
                    <div class="mt-2">
                      <strong class="my-label">ID:</strong>
                      {{payment.id}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card Name :</strong>
                      {{payment.card.name}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card No. :</strong>
                      xxxx-xxxx-xxxx-{{payment.card.last_digits}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Card Brand :</strong>
                      {{payment.card.brand}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Status :</strong>
                      {{payment.status}}
                    </div>
                    <div class="mt-2">
                      <strong class="my-label">Authorized :</strong>
                      {{payment.authorized}}
                    </div>
                  </v-flex>
                </v-layout>
              </section>
            </template>
            <v-divider></v-divider>

            <section class="pa-3" v-if="driver!=null">
              <h2 class="subtitle mb-3">ข้อมูลคนขับ</h2>
              <v-layout>
                <v-flex xs12>
                  <v-layout>
                    <v-flex xs3>
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="driver.driver.photo"
                        :fit="`contain`"
                      ></el-image>
                    </v-flex>
                    <v-flex xs9>
                      <div class="mt-2">
                        <strong class="my-label">เลขที่งาน:</strong>
                        {{order.driver_info_json.orderRef.substring(0, 5)}}-{{order.driver_info_json.orderRef.substring(5, 10)}}
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">สถานะ:</strong>
                        <span
                          class="red white--text py-1 px-3"
                          v-if="driver.detail.status=='CANCELED'"
                        >
                          <i class="far fa-times-circle"></i> ยกเลิกงานแล้ว
                        </span>
                        <span
                          class="green white--text py-1 px-3"
                          v-else-if="driver.detail.status=='COMPLETED'"
                        >
                          <i class="far fa-check-circle"></i> จัดส่งเรียบร้อยแล้ว
                        </span>
                        <span class="blue white--text py-1 px-3" v-else>{{driver.detail.status}}</span>
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">ชื่อคนขับ:</strong>
                        {{driver.driver.name}} | โทร. {{driver.driver.phone}}
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">ราคา:</strong>
                        ฿ {{driver.detail.price.amount}}
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">ติดตาม:</strong>
                        <a
                          :href="`https://share.lalamove.com/?TH`+order.driver_info_json.orderRef+`&lang=th_TH`"
                          target="_blank"
                        >https://share.lalamove.com/?TH{{order.driver_info_json.orderRef}}&lang=th_TH</a>
                      </div>
                      <div class="mt-2">
                        <strong class="my-label">Call Center:</strong>ต้องการยกเลิกงานโทร. 02-029-1494
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </section>
          </el-card>
        </div>
      </v-flex>
      <v-flex xs12 sm12 md4 :class="{'pl-4 mt-0': $vuetify.breakpoint.mdAndUp}">
        <div class="sticky">
          <el-card class="box-card">
            <div style="margin-top: 15px;">
              <el-input placeholder="Please input" v-model="shareUrl">
                <template slot="append">
                  <i class="far fa-copy"></i>
                </template>
              </el-input>
            </div>
            <v-divider class="my-3"></v-divider>
            <h3 class="subtitle pb-1 pt-4">หลักฐานการชำระเงิน</h3>
            <v-layout class="mt-3">
              <v-flex xs12 class="text-xs-center">
                <div
                  v-if="order.payment.payment_image_url!=null"
                  class="pa-3 mb-3"
                  style="background-color:#eee; border-radius:12px;"
                >
                  <h6 class="font-weight-bold">อัพโหลดโดยลูกค้า</h6>
                  <img :src="order.payment.payment_image_url" style="width:100%" />
                </div>
                <div
                  v-if="order.payment.payment_image_url_admin!=null"
                  class="pa-3 mb-3"
                  style="background-color:#eee; border-radius:12px;"
                >
                  <h6 class="font-weight-bold">อัพโหลดโดยแอดมิน</h6>
                  <img :src="order.payment.payment_image_url_admin" style="width:100%" />
                </div>
                <div
                  v-if="order.payment.payment_image_url==null && order.payment.payment_image_url_admin==null"
                  class="my-2 text-xs-center"
                >ยังไม่มีหลักฐานการชำระเงิน</div>
                <template v-if="order.status=='pending' || order.status=='new'">
                  <el-upload
                    class="upload-demo"
                    drag
                    :on-success="handleSuccess"
                    :file-list="file"
                    :action="deliveryApiDomain+`/console/orders/`+order.order_reference+`/upload`"
                    :headers="uploadHeaders"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      ส่งภาพการชำระเงิน
                      <em>กดที่นี่</em>
                    </div>
                    <!--
                    <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
                    -->
                  </el-upload>
                </template>
              </v-flex>
            </v-layout>
            <v-divider class="my-3"></v-divider>
            <section>
              <h3 class="subtitle pb-1 pt-4">ดำเนินการ</h3>
              <v-list>
                <template v-if="order.status=='new'">
                  <v-list-tile @click="onUpdateStatusTo('accepted')">
                    <v-list-tile-action>
                      <v-icon small>fas fa-check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>ยืนยันออเดอร์</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                </template>
                <template
                  v-if="order.status=='accepted' || order.status=='processing' || order.status=='cooking'"
                >
                  <template v-if="order.status=='accepted'">
                    <v-list-tile @click="onUpdateStatusTo('processing')">
                      <v-list-tile-action>
                        <v-icon small>fas fa-spinner</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>กำลังแพ็คของ</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                  </template>
                  <v-list-tile v-if="order.order_type=='delivery'" @click="onRequestDriverOpen">
                    <v-list-tile-action>
                      <v-icon small>fas fa-motorcycle</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>เรียกคนขับ Lalamove</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                </template>
                <template v-if="order.status=='processing' || order.status=='cooking'">
                  <v-list-tile @click="onUpdateStatusTo('completed')">
                    <v-list-tile-action>
                      <v-icon small>fas fa-check</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>จัดส่งแล้ว</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                </template>
                <template v-if="order.status=='cancelled'">
                  <v-list-tile @click="onUpdateStatusTo('new')">
                    <v-list-tile-action>
                      <v-icon small>fas fa-retweet</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>กลับสถานะ</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                </template>
                <template v-if="order.status!='cancelled'">
                  <v-list-tile @click="cancelOrderDialog = true">
                    <v-list-tile-action>
                      <v-icon small>far fa-window-close</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>ยกเลิกออเดอร์</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </section>
            <section v-if="order.payment=='creditcard'">
              <h3 class="subtitle pb-1 pt-4">การเงิน</h3>
              <v-list v-if="order.payment=='creditcard'">
                <template v-if="payment.capturable">
                  <v-list-tile @click="onCapturePayment">
                    <v-list-tile-content>
                      <v-list-tile-title>Capture</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                </template>
                <template v-if="payment.refundable">
                  <v-list-tile @click="onRefundPayment">
                    <v-list-tile-content>
                      <v-list-tile-title>Setup Refund</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider></v-divider>
                </template>
              </v-list>
            </section>
            <v-divider></v-divider>
            <section>
              <h3 class="subtitle pb-1 pt-4">อื่นๆ</h3>
              <v-list>
                <v-list-tile @click="recieptDialog = true">
                  <v-list-tile-action>
                    <v-icon small>fas fa-receipt</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>ดูใบเสร็จ</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>
              </v-list>
            </section>
          </el-card>
        </div>
      </v-flex>
    </v-layout>

    <el-dialog
      title="Reciept"
      v-if="order!=null"
      :visible.sync="recieptDialog"
      width="550px"
      center
    >
      <div>
        <v-layout class="mb-5" row>
          <v-flex xs7 offset-xs5>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>หมายเลขออเดอร์ :</strong>
              </el-col>
              <el-col
                :span="12"
                class="text-xs-right"
              >{{order.order_reference}}-{{order.order_id | numFormat('00000')}}</el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>สร้างเมื่อ :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">{{order.created_at}}</el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ประเภทการสั่งซื้อ :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">
                <div v-if="order.order_type=='pickup'">
                  <i class="fas fa-shopping-bag"></i> รับเองที่ร้าน
                </div>
                <div v-if="order.order_type=='delivery'">
                  <i class="fas fa-motorcycle"></i> เดลิเวอรี่
                </div>
                <div v-if="order.order_type=='commerce'">
                  <i class="fas fa-shopping-cart"></i> อีคอมเมิร์ซ
                </div>
                <div v-if="order.order_type=='coupon'">
                  <i class="fas fa-ticket-alt"></i> คูปอง/วอเชอร์โค้ด
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>การชำระเงิน :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">
                <div v-if="order.payment_type=='transfer'">โอนเงิน</div>
                <div v-if="order.payment_type=='cash'">ชำระเงินสด</div>
                <div v-if="order.payment_type=='creditcard'">บัตรเครดิต</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ช่องทางการขาย :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">
                <div v-if="order.order_channel=='liff'">Line Official Account</div>
                <div v-else>{{order.order_channel}}</div>
              </el-col>
            </el-row>
            <el-row :gutter="0" class="mt-2 subtitle">
              <el-col :span="12">
                <strong>ข้อมูลลูกค้า :</strong>
              </el-col>
              <el-col :span="12" class="text-xs-right">
                {{order.user_ref_json.firstname}} {{order.user_ref_json.lastname}}
                -
                <i
                  class="fas fa-mobile-alt"
                ></i>
                {{order.user_ref_json.mobile}}
              </el-col>
            </el-row>
          </v-flex>
        </v-layout>

        <template v-if="order.order_basket.product_list.length>0">
          <el-row
            :gutter="10"
            v-for="(item, index) in order.order_basket.product_list"
            v-bind:key="index"
          >
            <el-col :span="2" class="mb-3">
              <span>{{item.quantity}} x</span>
            </el-col>
            <el-col :span="17" class="mb-3">
              {{item.name}}
              <div v-if="item.modifiers!=null">
                <div
                  class="modifiers"
                  style="padding-left: 20px;"
                  v-for="(subject, index) in item.modifiers"
                  v-bind:key="index"
                >
                  {{subject.title}}
                  <div v-if="!subject.duplicate">
                    <div v-for="(item, j) in subject.items" v-bind:key="j">
                      <li class="choice-item" v-if="item.checked">{{item.name}}</li>
                    </div>
                  </div>
                  <div v-if="subject.duplicate">
                    <li
                      v-for="(item, j) in subject.items"
                      v-bind:key="j"
                    >{{item.name}} {{item.checked}}</li>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col
              :span="5"
              class="mb-3 text-xs-right"
            >฿ {{item.regular_price*item.quantity | numFormat('0,0')}}</el-col>
          </el-row>
          <v-divider class="my-3"></v-divider>
          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">ค่าอาหาร</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{order.amount.food | numFormat('0,0.00')}}</el-col>
          </el-row>
          <el-row :gutter="10" class="subtitle">
            <el-col :span="12" class="mb-3">ค่าจัดส่ง</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{parseFloat(order.amount.delivery)+parseFloat(order.amount.delivery_tax) | numFormat('0,0.00')}}</el-col>
          </el-row>
          <el-row :gutter="10" class="subtitle" v-if="order.amount.extra>0">
            <el-col :span="12" class="mb-3">ค่าบริการอื่นๆ</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{order.amount.extra | numFormat('0,0.00')}}</el-col>
          </el-row>
          <el-row :gutter="10" class="subtitle" v-if="order.amount.discount<0">
            <el-col :span="12" class="mb-3">ส่วนลด</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{order.amount.discount | numFormat('0,0.00')}}</el-col>
          </el-row>
          <el-row :gutter="10" class="title">
            <el-col :span="12" class="mb-3">รวมทั้งหมด</el-col>
            <el-col
              :span="12"
              class="mb-3 text-xs-right"
            >฿ {{order.amount.total | numFormat('0,0.00')}}</el-col>
          </el-row>
        </template>
        <!--
        <div
          class="my-2 text-xs-right"
        >*** จัดส่ง {{order.datetime_received | moment("DD/MM/YY HH:mm")}}</div>
        -->
        <div
          v-if="order.remark_public!=''"
          class="my-2 text-xs-left"
        >*** {{order.remark_public}} ***</div>
        <v-divider></v-divider>
        <!--
        <div v-if="order.payment_type=='cash'" class="my-3 text-xs-center">
          <label>โปรดชำระเงินที่</label>
          <div>019-1-80933-5</div>
          <div>บจก. ฮาลาลไลซ์ | ธนาคารกสิกรไทย</div>
        </div>
        -->
        <div class="my-3 text-xs-center">
          <div>Thank You</div>
        </div>
      </div>
    </el-dialog>

    <v-dialog v-model="cancelOrderDialog" scrollable max-width="400px">
      <v-card>
        <v-card-title>
          <strong>Select cancel reason</strong>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 350px;">
          <v-radio-group v-model="cancelReason">
            <v-radio
              class="mt-2"
              color="primary"
              label="สินค้าไม่พอจำหน่าย"
              value="สินค้าไม่พอจำหน่าย"
            ></v-radio>
            <v-radio class="mt-2" color="primary" label="ลูกค้ายกเลิก" value="ลูกค้ายกเลิก"></v-radio>
            <v-radio class="mt-2" color="primary" label="ออเดอร์ทดสอบ" value="ออเดอร์ทดสอบ"></v-radio>
            <v-radio class="mt-2" color="primary" label="อื่นๆ" value="อื่นๆ"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="cancelOrderDialog = false">ปิด</v-btn>
          <v-btn color="primary" flat @click="onUpdateStatusTo('cancelled')">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- v-if="order.driver_info_json!=null" -->
    <driver-dialog
      :deliveryData="deliveryData"
      :order="order"
      :showDialog="driverDialog"
      @save="onSaveDriver"
      @close="onRequestDriverClose"
    ></driver-dialog>
  </v-container>
</template>
<script>
import { deliveryApiDomain, harisChannelKey } from "../../../utils/Constants";

import Service from "../../../services";

const DriverDialog = () => import("@/components/DriverDialog");

export default {
  components: {
    DriverDialog
  },
  props: ["order_ref"],
  data() {
    return {
      deliveryApiDomain: deliveryApiDomain,
      loading: null,
      order: null,
      payment: null,
      driver: null,
      shareUrl: "",
      recipient: { name: "", mobile: "", email: "" },
      cancelReason: null,
      shippingAddress: null,
      driverDialog: false,
      deliveryData: null,
      recieptDialog: false,
      cancelOrderDialog: false,
      file: [],
      uploadHeaders: {
        Authorization: ""
      },
      steps: [1, 0, 0, 0, 0]
    };
  },
  computed: {},
  created() {
    let vuex = JSON.parse(localStorage.getItem("halalize"));
    let accessToken = vuex.Auth.accessToken;
    this.uploadHeaders.Authorization = "Bearer " + accessToken;

    this.loadOrder();
  },
  methods: {
    loadOrder() {
      this.showLoading();
      Promise.all([
        this.$store
          .dispatch("Order/getOrderByRef", this.order_ref)
          .then(res => {
            if (res.status == "ok") {
              this.order = res.data;
              this.shippingAddress = res.data.user_address;
              this.checkRecipient();
              this.shareUrl =
                "https://get.hlzd.link/o/" +
                this.order.order_reference.toLowerCase();

              if (this.order.status == "new") {
                this.steps[1] = 1;
              }
              if (this.order.status == "acccepted") {
                this.steps[1] = 1;
                this.steps[2] = 1;
              }
              if (this.order.status == "processing") {
                this.steps[1] = 1;
                this.steps[2] = 1;
                this.steps[3] = 1;
              }
              if (this.order.status == "completed") {
                this.steps[1] = 1;
                this.steps[2] = 1;
                this.steps[3] = 1;
                this.steps[4] = 1;
              }
            }
          }),

        this.$store
          .dispatch("Order/getOrderPayment", this.order_ref)
          .then(res => {
            this.payment = res.data;
          })
      ]).then(() => {
        this.hideLoading();

        this.$store
          .dispatch("Order/getOrderDriver", this.order.order_id)
          .then(res => {
            this.driver = res.data;
          });
      });
    },
    checkRecipient() {
      if (this.order.user_recipient == null) {
        this.recipient.name = this.order.user_ref_json.firstname;
        this.recipient.mobile = this.order.user_ref_json.mobile;
        this.recipient.email = this.order.user_ref_json.email;
      } else {
        this.recipient.name = this.order.user_recipient.recipient_name;
        this.recipient.mobile = this.order.user_recipient.recipient_mobile;
        this.recipient.email = this.order.user_recipient.email;
      }
    },
    onRequestDriverOpen() {
      this.deliveryData = {
        orderId: this.order.order_id,
        datetimeReceived: this.order.datetime_received,
        deliveryInfo: this.order.delivery_info_json,
        recipientInfo: this.order.user_ref_json
      };
      this.driverDialog = true;
    },
    onRequestDriverClose() {
      this.delivery_info = null;
      this.driverDialog = false;
    },
    onSaveDriver() {
      this.delivery_info = null;
      this.driverDialog = false;
    },
    onUpdateStatusTo(status) {
      this.showLoading();
      let data = {
        status: status,
        remark_internal: ""
      };

      if (status == "cancelled") {
        data.remark_internal = this.cancelReason;
      }

      Service.Order.updateStatus(this.order.order_id, data).then(res => {
        if (res.success) {
          this.cancelOrderDialog = false;
          this.loadOrder();
        }
      });
    },
    onCapturePayment() {
      Service.Order.capturePayment(this.order.order_id).then(res => {
        if (res.success) {
          this.$store
            .dispatch("Order/getOrderPayment", this.order_id)
            .then(res => {
              this.payment = res.data;
            });
        }
      });
    },
    onRefundPayment() {},
    showLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
    },
    hideLoading() {
      this.loading.close();
    },
    handleSuccess() {}
  }
};
</script>
<style lang="scss">
.promotion {
  font-weight: bold;
  border-radius: 8px;
}

.el-upload-dragger {
  width: 200px !important;
}
</style>
